
import Vue from 'vue'
import { Agency } from '@/domains/global/models'
import { Prop, Component } from 'vue-property-decorator'
import AccountTypeCard from './AccountTypeCard.vue'

@Component({
  components: { AccountTypeCard }
})
export default class AgencyTypeDetails extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  private readonly agency!: Agency

  get isTranslationAgency (): boolean {
    return !!this.agency.isTranslationAgency
  }

  set isTranslationAgency (value: boolean) {
    this.$emit('update:agency', { ...this.agency, isTranslationAgency: value })
  }

  get isMigrationAgency (): boolean {
    return !!this.agency.isMigrationAgency
  }

  set isMigrationAgency (value: boolean) {
    this.$emit('update:agency', { ...this.agency, isMigrationAgency: value })
  }
}
